<div class="forecast-duration" [matTooltip]="'app.forecast.edit.forecast.tooltip' | translate">
  <span class="currency-icon {{ forecastCurrency }}"></span>
  <span class="flex-inline flex-direction-c">
    <span class="currency-code">{{ forecastCurrency }}</span>
    @if (marketingPlanDuration) {
    <span class="forecast-duration-yr">
      {{ marketingPlanDuration }}{{ 'app.modal.forecast.yr.label' | translate }}
    </span>
    }
  </span>
</div>
